export default __webpack_public_path__ + "static/media/login-banner-2.20ec9bfb.png";